import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext, StateToken } from '@ngxs/store';
import { MediaStateModel } from '../media/media-state.model';
import { CallStateModel } from './call-state.model';
import { CallActions } from './call.actions';

const CALL_STATE_TOKEN: StateToken<MediaStateModel> = new StateToken('CallState');

const DEFAULT_STATE: CallStateModel = {
    callActive: false,
    chatOpen: false,
    settingsOpen: false,
    callStatus: null,
};

@State<CallStateModel>({
    name: CALL_STATE_TOKEN,
    defaults: DEFAULT_STATE,
    children: [],
})
@Injectable()
export class CallState {
    @Selector() static callActive(state: CallStateModel) {
        return state.callActive;
    }

    @Selector() static chatOpen(state: CallStateModel) {
        return state.chatOpen;
    }

    @Selector() static settingsOpen(state: CallStateModel) {
        return state.settingsOpen;
    }

    @Selector() static callStatus(state: CallStateModel) {
        return state.callStatus;
    }

    @Action(CallActions.SetCallStatus)
    setCallStatus(ctx: StateContext<CallStateModel>, action: CallActions.SetCallStatus) {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            callStatus: action.status,
        });
    }

    @Action(CallActions.ToggleChat)
    toggleChat({ patchState, getState }: StateContext<CallStateModel>) {
        patchState({ chatOpen: !getState().chatOpen });
    }

    @Action(CallActions.ToggleSettings)
    toggleSettings({ patchState, getState }: StateContext<CallStateModel>) {
        patchState({ settingsOpen: !getState().settingsOpen });
    }

    @Action(CallActions.StartCall)
    startCall({ patchState }: StateContext<CallStateModel>) {
        patchState({ callActive: true });
    }

    @Action(CallActions.EndCall)
    endCall({ patchState }: StateContext<CallStateModel>) {
        patchState({ callActive: false });
    }
}
